function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4 4)"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  cx: 8,
  cy: 8,
  r: 8
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 2.133a5.867 5.867 0 01.531 11.71v-1.969c1.74-.255 3.185-1.751 3.185-3.567h-.903c0 1.593-1.348 2.707-2.813 2.707S5.187 9.9 5.187 8.307h-.903c0 1.81 1.444 3.307 3.185 3.567v1.969A5.867 5.867 0 018 2.133zM8 3.53a1.59 1.59 0 00-1.592 1.593v3.184a1.59 1.59 0 103.18 0l.004-3.184A1.59 1.59 0 008 3.53z",
  fill: "#0592AF"
})));

function SvgAudioRecordingBadgeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default SvgAudioRecordingBadgeIcon;